<template>
  <SfProductCard
    :title="product.name"
    :image="getImage(product.image)"
    :regular-price="productPrice(product)"
    :max-rating="5"
    :score-rating="product.rating"
    :isOnWishlist="isOnWishlist(product.id)"
    :link="{ name: 'product', params: { slug: product.slug } }"
    class="products__product-card"
    @click:wishlist="$emit('toggleProductWishlist', product)"
  >
    <template #price>
      <div class="sf-price sf-product-card__price">
        <span class="sf-price__regular">{{ productPrice(product) }}</span>
      </div>  
      <div class="sf-price sf-product-card__price" style="display: flex; justify-content: space-between; align-items: center;">
        <router-link :to="{ name: 'shop', params: { shop: product.shop.slug } }">
          {{ product.shop.name }}
        </router-link>
        <svg v-if="product.shop.delivery" width="24px" height="24px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <g>
            <g>
              <path d="M476.158,231.363l-13.259-53.035c3.625-0.77,6.345-3.986,6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392
                V110.63c0-9.136-7.432-16.568-16.568-16.568H50.772c-9.136,0-16.568,7.432-16.568,16.568V256c0,4.427,3.589,8.017,8.017,8.017
                c4.427,0,8.017-3.589,8.017-8.017V110.63c0-0.295,0.239-0.534,0.534-0.534h307.841c0.295,0,0.534,0.239,0.534,0.534v145.372
                c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-9.088h94.569c0.008,0,0.014,0.002,0.021,0.002
                c0.008,0,0.015-0.001,0.022-0.001c11.637,0.008,21.518,7.646,24.912,18.171h-24.928c-4.427,0-8.017,3.589-8.017,8.017v17.102
                c0,13.851,11.268,25.119,25.119,25.119h9.086v35.273h-20.962c-6.886-19.883-25.787-34.205-47.982-34.205
                s-41.097,14.322-47.982,34.205h-3.86v-60.393c0-4.427-3.589-8.017-8.017-8.017c-4.427,0-8.017,3.589-8.017,8.017v60.391H192.817
                c-6.886-19.883-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205H50.772c-0.295,0-0.534-0.239-0.534-0.534v-17.637
                h34.739c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H8.017c-4.427,0-8.017,3.589-8.017,8.017
                s3.589,8.017,8.017,8.017h26.188v17.637c0,9.136,7.432,16.568,16.568,16.568h43.304c-0.002,0.178-0.014,0.355-0.014,0.534
                c0,27.996,22.777,50.772,50.772,50.772s50.772-22.776,50.772-50.772c0-0.18-0.012-0.356-0.014-0.534h180.67
                c-0.002,0.178-0.014,0.355-0.014,0.534c0,27.996,22.777,50.772,50.772,50.772c27.995,0,50.772-22.776,50.772-50.772
                c0-0.18-0.012-0.356-0.014-0.534h26.203c4.427,0,8.017-3.589,8.017-8.017v-85.511C512,251.989,496.423,234.448,476.158,231.363z
                M375.182,144.301h60.392c9.725,0,17.637,7.912,17.637,17.637v0.534h-78.029V144.301z M375.182,230.881v-52.376h71.235
                l13.094,52.376H375.182z M144.835,401.904c-19.155,0-34.739-15.583-34.739-34.739s15.584-34.739,34.739-34.739
                c19.155,0,34.739,15.583,34.739,34.739S163.99,401.904,144.835,401.904z M427.023,401.904c-19.155,0-34.739-15.583-34.739-34.739
                s15.584-34.739,34.739-34.739c19.155,0,34.739,15.583,34.739,34.739S446.178,401.904,427.023,401.904z M495.967,299.29h-9.086
                c-5.01,0-9.086-4.076-9.086-9.086v-9.086h18.171V299.29z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M144.835,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568
                c9.136,0,16.568-7.432,16.568-16.568C161.403,358.029,153.971,350.597,144.835,350.597z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M427.023,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568
                c9.136,0,16.568-7.432,16.568-16.568C443.591,358.029,436.159,350.597,427.023,350.597z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M332.96,316.393H213.244c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H332.96
                c4.427,0,8.017-3.589,8.017-8.017S337.388,316.393,332.96,316.393z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M127.733,282.188H25.119c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614
                c4.427,0,8.017-3.589,8.017-8.017S132.16,282.188,127.733,282.188z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M278.771,173.37c-3.13-3.13-8.207-3.13-11.337,0.001l-71.292,71.291l-37.087-37.087c-3.131-3.131-8.207-3.131-11.337,0
                c-3.131,3.131-3.131,8.206,0,11.337l42.756,42.756c1.565,1.566,3.617,2.348,5.668,2.348s4.104-0.782,5.668-2.348l76.96-76.96
                C281.901,181.576,281.901,176.501,278.771,173.37z"/>
            </g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
          <g>
          </g>
        </svg>
      </div>
    </template>
  </SfProductCard>
</template>

<script>
import {
  SfProductCard
} from '@storefront-ui/vue';

export default {
  props: {
    product: Object,
    isOnWishlist: Function
  },

  components: {
    SfProductCard
  },

  methods: {
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },

    productPrice(product) {
      let price = 0;
      // Fonon
      if(product.shop.id === 22) {
        if(product.price) {
          price = product.price
        } else if(product.weight && (product.specification_insert == 'empty' && product.specification_insert2 == 'empty')) {
          if(product.specification_probe == 583 || product.specification_probe == 585) {
            price = product.weight * product.shop.probe_583_price
          } else if(product.specification_probe == 750) {
            price = product.weight * product.shop.probe_750_price
          }
        }
      }
      // jeWell
      else if(product.shop.id === 21 || product.shop.id === 19) {
        price = 10581 * product.price
      } else {
        price = product.price
      }

      if(price) {
        return Intl.NumberFormat('uz-UZ', { minimumFractionDigits: 0 }).format(price) + ' сум'
      } else return ''
    }
  }
}
</script>

<style>

</style>